'use client';

import { type ReactNode } from 'react';

import {
    CartService,
    CorbisRepository,
    CustomerRepository,
    FapiRepository,
    GrapiRepository,
    PapiRepository,
    PulcoRepository,
    SapiRepository,
    localStorageRepository,
} from '@bytel/leviator';
import { CartProvider } from '@bytel/leviator/react';

import { getAppConfig } from '@services/config';
import { vapiHttpService } from '@services/http';

import { OneCartRepository } from '@repositories/one-cart';

import { RecoverCartLogin } from '@components/trigger-login';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const appConfig = getAppConfig();

interface VirtualCartProviderProps {
    children: ReactNode;
}

const sapiRepository = new SapiRepository({ sapiUrl: appConfig.b2r.url }, vapiHttpService);
const grapiRepository = new GrapiRepository({ grapiUrl: appConfig.b2r.url }, vapiHttpService);
const corbisRepository = new CorbisRepository({ corbisUrl: appConfig.b2r.url }, vapiHttpService);
const customerRepository = new CustomerRepository({ refcliUrl: appConfig.b2r.url }, vapiHttpService);
const pulcoRepository = new PulcoRepository({ pulcoUrl: appConfig.b2r.url }, vapiHttpService);
const papiRepository = new PapiRepository({ papiUrl: appConfig.b2r.url }, vapiHttpService);
const fapiRepository = new FapiRepository({ fapiUrl: appConfig.b2r.url }, vapiHttpService);

const cartRepository = new OneCartRepository({
    config: {
        vapiUrl: appConfig.b2r.url,
    },
    storageRepository: localStorageRepository,
    sapiRepository,
    grapiRepository,
    corbisRepository,
    customerRepository,
    pulcoRepository,
    papiRepository,
    fapiRepository,
    httpService: vapiHttpService,
});

const cartService = new CartService(cartRepository);

export function VirtualCartProvider({ children }: Readonly<VirtualCartProviderProps>) {
    return (
        <>
            <CartProvider cartService={cartService} cartType='virtual'>
                {children}
                <RecoverCartLogin />
            </CartProvider>
            <ReactQueryDevtools buttonPosition='bottom-left' />
        </>
    );
}
